module.exports = __webpack_public_path__ + "img/ad1.1ab8c25d.png";